import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOracle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "800px",
	height: "800px",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#EA1B22",
		fillRule: "evenodd",
		d: "M.1 8c0 2.761 2.237 5 4.997 5h5.806A4.999 4.999 0 0015.9 8c0-2.761-2.237-5-4.997-5H5.097A4.999 4.999 0 00.1 8zm13.911 0a3.235 3.235 0 01-3.234 3.237h-5.55A3.235 3.235 0 011.991 8a3.235 3.235 0 013.234-3.236h5.551A3.235 3.235 0 0114.011 8z",
		clipRule: "evenodd"
	})
});
export default SvgOracle;
